import useAuth from 'hooks/use-auth'
import { CarrierFeatures } from 'features/auth/types'

// Everything is on unless the carrier's profile says otherwise, so a slow or
// older profile response never blanks out a feature the carrier does licence.
const ALL_FEATURES: CarrierFeatures = {
  secureScore: true,
  cyraAi: true,
  riskProfileScore: true,
}

const useCarrierFeatures = (): CarrierFeatures => {
  const { user } = useAuth()
  return { ...ALL_FEATURES, ...(user?.features || {}) }
}

export default useCarrierFeatures
